import { CONTENT_CONFIG } from "src/assets/content_config";
export const environment = {
  production: false,
  version:'0.0.1',
  content: CONTENT_CONFIG,
  COMPANY_ID: "UNITYCRM0021",


 CAS_BASE_RUL:'https://identity-stg.aqsatel.com/',
  BASE_API: "https://manage-api.aqsatel.com/",
  AQSATEL_API: "https://manage-api.aqsatel.com/",
  Prepaid_Mingle_API: "https://mingle-stg-api.aqsatel.com/",


  UNITY_BUYFLOW: "https://prepaid.unitywireless.com",
  MINGLE_BUYFLOW: "https://prepaid.minglemobile.com",

  USER_ID: "1",
  FETCH_DATA_REPORT_TABLE_INTERVAL: 3,
  PREPAID_UNITYWIRELESS: "https://prepaid.unitywireless.com/",

  MINGLE_MOBILE: "https://minglemobile.com",
  // session timeout or user inactivity constants
  INACTIVITY_SCREEN_TIME_IN_MINIUTES: 60,
  JWT_EXPIRATION_TIME_IN_MINUTES: 60,
  JWT_EXPIRATION_WARNING_TIME_IN_MINUTES: 5,
  INACTIVITY_SCREEN_TIMEOUT_TIME_IN_Millisconds: 60000,
  // notification keys
  REVERB_APP_KEY: 'l1ylkjx1fe40lqlskwce',
  REVERB_HOST: 'prepaid-api.aqsatel.com',
  REVERB_PORT: 8081,
  REVERB_SCHEME: 'http',
  //searchHistoryRetention Variables
  searchHistoryStorageBasis: "days", // Use 'days' or 'login'
  searchHistoryDaysToKeep: 2, // default days to retain records if day-based is selected
  // searchHistoryDaysToKeep will totally irrelevent in case of searchHistoryStorageBasis= login
  // Data unit conversion factor: 1000 = decimal (GB/MB), 1024 = binary (GiB/MiB)
  DATA_UNIT_CONVERSION: 1000,

  // Logging controls
  enableConsoleLogs: true,
  TE_AGENT_BASE_URL: 'https://assistance.telcoedge.com',
  COMPANY_INFO: {
    unityWireless: {
      phoneNo: '(954) 613 6051',
      officialName: 'Unity Wireless',
      supportEmail: 'support@gounitywireless.com',
      companyAddress: '21113 Johnson St. Ste 101 Pembroke Pines FL 33029',
      copyrightDescription: '© 2024 Unity Wireless All Rights Reserved.'
    },
    mingleMobile: {
      phoneNo: '(800) 974 6122',
      officialName: 'Mingle Mobile',
      supportEmail: 'support@minglemobile.com',
      companyAddress: '21113 Johnson St. Ste 101 Pembroke Pines FL 33029',
      copyrightDescription: '© 2024 Mingle Mobile All Rights Reserved.'
    }
  }
};
